@import '../../utils/field-stack.css';

:host {
  display: block;
}

.field__control {
  display: flex;
  min-width: 0;
}

.field__control > * {
  width: 100%;
}
